
import TranslationHelper from './TranslationHelper';

export default TranslationHelper;



// WEBPACK FOOTER //
// ./src/helpers/TranslationHelper/index.js